import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (!date || !displayFormat) {
            return '';
        }
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }
}

@Injectable()
export class CustomAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (!date || !displayFormat) {
            return '';
        }
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en', { month: 'short' });
        const year = date.getFullYear();
        const time = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        return `${day} ${month} ${year}, ${time}`;
    }
}